var _dec, _dec2, _dec3, _class, _class2, _temp;

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import * as React from 'react';
import translate from '4finance-translate-pl';
import { Form } from '4finance-onion-form-pl';
import RecoverType from '../../enums/recoverType';
import timer from '../hoc/timer.decorator';
import { connectState, connectActions } from '../../redux/connect';
import { SubmitButton } from '../../fields';
var ResendButton = (_dec = connectState({
  recoverType: ['passwordRecover', 'recoverType']
}), _dec2 = connectActions({
  actions: ['passwordActions']
}), _dec3 = timer(60), _dec(_class = _dec2(_class = _dec3(_class = translate(_class = (_temp = _class2 = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ResendButton, _React$PureComponent);

  function ResendButton() {
    _classCallCheck(this, ResendButton);

    return _possibleConstructorReturn(this, _getPrototypeOf(ResendButton).apply(this, arguments));
  }

  _createClass(ResendButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          actions = _this$props.actions,
          counter = _this$props.counter,
          msg = _this$props.msg,
          recoverType = _this$props.recoverType;
      var disabled = counter >= 1;
      var isEmailRecover = recoverType === RecoverType.EMAIL_RECOVER;
      var submitAction = isEmailRecover ? actions.setEmailRecover : actions.setPhoneRecover;
      var buttonText = isEmailRecover ? msg('emailSent.tryAgain') : msg('checkRecoverData.resendButton');
      var secondsText = isEmailRecover ? msg('emailSent.seconds') : msg('checkRecoverData.seconds');
      return React.createElement(Form, {
        name: "resendRecoverData",
        onSubmit: submitAction
      }, React.createElement(SubmitButton, {
        disabled: disabled,
        kind: "white"
      }, buttonText, disabled && " (".concat(counter, " ").concat(secondsText, ")")));
    }
  }]);

  return ResendButton;
}(React.PureComponent), _defineProperty(_class2, "defaultProps", {
  actions: {},
  msg: function msg() {
    return '';
  },
  counter: 0
}), _temp)) || _class) || _class) || _class) || _class);
export { ResendButton as default };